import React from "react";
import Select, { SelectProps, transformDataToSelectOption } from "@/components/atoms/Select";
import { useGetCompanyTeam } from "@/services/Company";
import UserMembershipTypeEnum from "@/constants/enums/UserMembershipTypeEnum";
import { GetTeamMember } from "@/types";
import { useAuth } from "@/contexts/AuthContext";

type keyOptions = Extract<keyof GetTeamMember, string>;

interface SelectPropsExtended extends SelectProps {
  valueKey: keyOptions;
  labelKey: keyOptions | keyOptions[];
}

/**
 * SelectCondition component renders a Select dropdown for conditions.
 * - Uses translation for option labels.
 * @param {SelectPropsExtended} props - Props for the SelectCondition component.
 * @param {keyOptions} props.valueKey - Key to use for option values.
 * @param {keyOptions} props.labelKey - Key to use for option labels.
 */
const SelectTeamMember: React.FC<SelectPropsExtended> = ({ valueKey, labelKey, ...restProps }: SelectPropsExtended) => {
  const { currentCompany } = useAuth();
  const { data: teamMembers, isLoading } = useGetCompanyTeam(currentCompany?.companyId as number, {
    enabled: !!currentCompany?.companyId,
  });

  const sourceData =
    teamMembers?.activeUsers.filter((member) => member.roleType !== UserMembershipTypeEnum.VIEWER) || [];
  const options = transformDataToSelectOption(sourceData, valueKey || "id", labelKey || "value");

  return <Select data={options} loading={isLoading} {...restProps} />;
};
export default SelectTeamMember;
